import { UILastAutoDrafts, UiResumeDraftResponse } from '@/models/BuilderModels/DraftListItem';
import { CopyRequest } from '@/models/BuilderModels/InitiateRequest';
import { ClausesGroup } from '@/components/AttorneyRegistration/Component/Models/ClausesGroup';
import { BuilderBemogabWekalaVM } from '@/models/BuilderModels/BuilderBemogabWekalaVM';
import { EndDateRequestModel } from '@/models/BuilderModels/EndDateRequestModel';
import { PartyResponseModel } from '@/models/BuilderModels/PartyResponseModel';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';
import { ClauseResponse } from '@/components/AttorneyRegistration/Component/Models/ClauseResponse';



//@Module({ namespaced: true })
@Module({})
export default class BuilderStore extends VuexModule {


  //State
  reference: string | null = null;
  firstPartyList: PartyResponseModel[] | null = null;
  secondPartyList: PartyResponseModel[] | null = null;
  IsWakeelTogether: boolean = false;
  IsCopyWekala: boolean = false;
  IsRenew: boolean = false;
  copyRequest: CopyRequest = {} as CopyRequest;
  ClausesGroups: ClausesGroup[] = [];
  EndDate: EndDateRequestModel = {} as EndDateRequestModel;

  selectedClauses: ClauseResponse[] = [];
  selectedGroups: ClausesGroup[] = [];
  
  uiCards: UILastAutoDrafts | null = null;
  isDraft: boolean = false;
  resumeResponse: UiResumeDraftResponse = {} as UiResumeDraftResponse;



  builderBemogabWekala: BuilderBemogabWekalaVM = {} as BuilderBemogabWekalaVM;


  //Getters
  get getReference(): string | null {
    return this.reference;
  }

  get getIsDraft(): boolean {
    return this.isDraft;
  }

  get getResumeResponse(): UiResumeDraftResponse {
    return this.resumeResponse;
  }

  get getfirstPartyList(): PartyResponseModel[] | null {
    return this.firstPartyList;
  }

  get getsecondPartyList(): PartyResponseModel[] | null {
    return this.secondPartyList;
  }

  get getIsWakeelTogether(): boolean {
    return this.IsWakeelTogether;
  }

  get getIsCopyWekala(): boolean {
    return this.IsCopyWekala;
  }

  get getIsReIssueWekala(): boolean {
    return this.IsRenew;
  }

  get getclausesGroups(): ClausesGroup[] {

    //Fill Selected Count 

    let selectedclausesRes = this.selectedClauses.filter((c) => c.parentControlID == null);

    this.ClausesGroups.forEach(s => {
      let c = selectedclausesRes.filter((c) => c.attorneyTypeID == s.id);
      s.uiSelectedCount = c.length;
    });

    return this.ClausesGroups;
  }

  get getEndDate(): EndDateRequestModel {
    return this.EndDate;
  }

  get getBemogabWekala(): BuilderBemogabWekalaVM {
    return this.builderBemogabWekala;
  }

  get getCopyRequest(): CopyRequest {
    return this.copyRequest;
  }

  get getSelectedClauses(): ClauseResponse[] {
    return this.selectedClauses;
  }

  get getLastAutoDraftsFromStore(): UILastAutoDrafts | null {
    return this.uiCards;
  }


  public isSelectedClause(clausetoCheck: ClauseResponse): boolean {
    let selected = this.selectedClauses.filter(
      (s) => s.id === clausetoCheck.id
    );

    if (selected && selected.length > 0) {
      return true;
    }
    return false;
  }

  get getIsValidFromStore(): number[] {
    let ret = true;
    let invalidGroups: number[] = [];

    this.selectedClauses.forEach((cls) => {
      let reqChilds = cls.clauses.filter(
        (c) => c.isRequired && c.isHiddenWhenNoValue == false
      );

      if (reqChilds && reqChilds.length > 0) {
        reqChilds.forEach((ch) => {
          let selected = this.selectedClauses.find((s) => s.id === ch.id);
          if (selected) {
          } else {
            ret = false;
            invalidGroups.push(ch.attorneyTypeID);
          }
        });
      }
    });
    return invalidGroups;
  }

  get getSelectedGroups(): ClausesGroup[] {
    return this.selectedGroups;
  }


  //Mutations
  @Mutation
  public setReferenceMut(reference: string): void {
    this.reference = reference;
  }

  @Mutation
  public setIsDraftMut(isDraft: boolean): void {
    this.isDraft = isDraft;
  }

  @Mutation
  public setResumeResponseMut(response: UiResumeDraftResponse): void {
    this.resumeResponse = response;
  }

  @Mutation
  public set_firstPartyList_Mut(firstPartyList: PartyResponseModel[]): void {
    this.firstPartyList = firstPartyList;
  }

  @Mutation
  public set_secondPartyList_Mut(secondPartyList: PartyResponseModel[]): void {
    this.secondPartyList = secondPartyList;
  }

  @Mutation
  public set_IsWakeelTogether_Mut(isWakeelTogether: boolean): void {
    this.IsWakeelTogether = isWakeelTogether;
  }

  @Mutation
  public set_IsCopyWekala_Mut(isCopyWekala: boolean): void {
    this.IsCopyWekala = isCopyWekala;
  }

  @Mutation
  public set_setIsReIssueWekala_Mut(isRenew: boolean): void {
    this.IsRenew = isRenew;
  }

  @Mutation
  public set_clausesGroups_Mut(clausesGroups: ClausesGroup[]): void {
    this.ClausesGroups = clausesGroups;
  }

  @Mutation
  public set_EndDate_Mut(endDate: EndDateRequestModel): void {
    this.EndDate = endDate;
  }

  @Mutation
  public AddSelectedClause(item: ClauseResponse): void {
    this.selectedClauses.push(item);
  }

  @Mutation
  public addSelectedClauseActionGroupMut(item: ClauseResponse[]): void {
    this.selectedClauses = [];
    this.selectedClauses = item;
  }

  @Mutation
  public removeSelectedClause(item: ClauseResponse): void {
    let index = this.selectedClauses.findIndex((cls) => cls.id === item.id);

    if (index > -1) {
      this.selectedClauses.splice(index, 1);
    }
  }

  @Mutation
  public AddPreSelectedClausesListMut(list: ClauseResponse[]): void {
    // // debugger;
    this.selectedClauses = list;
  }

  @Mutation
  public set_ClearModel_Mut(): void {
    this.reference = null;
    this.isDraft = false;
    this.firstPartyList = [];
    this.secondPartyList = [];
    this.IsWakeelTogether = false;
    this.ClausesGroups = [];
    this.EndDate = {} as EndDateRequestModel;
    this.selectedClauses = [];
    this.selectedGroups = [];
    this.IsCopyWekala = false;
    this.copyRequest = {} as CopyRequest;
    this.resumeResponse = {} as UiResumeDraftResponse;
    this.builderBemogabWekala = {} as BuilderBemogabWekalaVM;
  }

  @Mutation
  public set_bemogabWekala_Mut(model: BuilderBemogabWekalaVM): void {
    this.builderBemogabWekala = model;
  }

  @Mutation
  public set_copyRequest_Mut(model: CopyRequest): void {
    this.copyRequest = model;
  }

  @Mutation
  public setSelectedGroupsMut(groups: ClausesGroup[]): void {
    this.selectedGroups = groups;
  }

  @Mutation
  public removeSelectedGroup(item: ClausesGroup): void {
    let index = this.selectedGroups.findIndex((clsg) => clsg.id === item.id);

    if (index > -1) {
      this.selectedGroups.splice(index, 1);
    }
  }

  @Mutation
  public setUiCardsMut(uiCards: UILastAutoDrafts): void {
    this.uiCards = uiCards;
  }


  @Action
  public setUiCards(uiCards: UILastAutoDrafts): void {
    this.context.commit('setUiCardsMut', uiCards);
  }


  @Action
  public setReference(reference: string): void {
    this.context.commit('setReferenceMut', reference);
  }

  @Action
  public setIsDraft(isdraft: boolean): void {
    this.context.commit('setIsDraftMut', isdraft);
  }

  @Action
  public setResumeResponse(response: UiResumeDraftResponse): void {
    this.context.commit('setResumeResponseMut', response);
  }

  @Action
  public setFirstPartyList(firstPartyList: PartyResponseModel[]): void {
    this.context.commit('set_firstPartyList_Mut', firstPartyList);
  }

  @Action
  public setSecondPartyList(secondPartyList: PartyResponseModel[]): void {
    this.context.commit('set_secondPartyList_Mut', secondPartyList);
  }

  @Action
  public setIsWakeelTogether(isWakeelTogether: boolean): void {
    this.context.commit('set_IsWakeelTogether_Mut', isWakeelTogether);
  }

  @Action
  public setIsCopyWekala(isCopyWekala: boolean): void {

    this.context.commit('set_IsCopyWekala_Mut', isCopyWekala);
    if (isCopyWekala == false) {
      this.context.commit('set_copyRequest_Mut', {});
    }
  }

  @Action
  public setIsReIssueWekala(isReIssueWekala: boolean): void {
    this.context.commit('set_setIsReIssueWekala_Mut', isReIssueWekala);
  }

  @Action
  public setClausesGroup(clausesGroups: ClausesGroup[]): void {
    this.context.commit('set_clausesGroups_Mut', clausesGroups);
  }
  @Action
  public updateEndDate(endDate: EndDateRequestModel): void {
    this.context.commit('set_EndDate_Mut', endDate);
  }

  @Action
  public clearState(): void {
    this.context.commit('set_ClearModel_Mut');
  }

  @Action
  public setBemogabWekala(model: BuilderBemogabWekalaVM): void {
    this.context.commit('set_bemogabWekala_Mut', model);
  }

  @Action
  public setCopyRequest(model: CopyRequest): void {
    this.context.commit('set_copyRequest_Mut', model);
  }

  @Action
  public addSelectedClauseAction(clause: ClauseResponse): void {
    let index = this.selectedClauses.findIndex((cls) => cls.id === clause.id);

    if (index > -1) {
      this.selectedClauses.splice(index, 1);
    }
    this.context.commit('AddSelectedClause', clause);
  }

  @Action
  public removeClausesByGroup(clauseGroup: ClausesGroup): void {
    let index = this.selectedClauses.filter(
      (s) => s.attorneyTypeID === clauseGroup.id
    );

    if (index && index.length > 0) {
      index.forEach((s) => {
        this.context.commit('removeSelectedClause', s);
      });
    }

    let indexg = this.selectedGroups.filter((s) => s.id === clauseGroup.id);
    if (indexg && indexg.length > 0) {
      indexg.forEach((s) => {
        this.context.commit('removeSelectedGroup', s);
      });
    }
  }

  @Action
  public addSelectedClauseActionGroup(clause: ClauseResponse[]): void {
    this.context.commit('addSelectedClauseActionGroupMut', clause);
  }

  @Action
  public removeSelectedClauseAction(clause: ClauseResponse): void {
    this.context.commit('removeSelectedClause', clause);
  }


}
